// extracted by mini-css-extract-plugin
module.exports = {"root":"w_M","blurBackground":"w_bw","wrapper":"w_bx","branding":"w_by","toggleNavButton":"w_bz"};